module.exports = __webpack_public_path__ + "static/media/Soleil-Regular.e26d1cbb.otf";